import { useSelector } from 'react-redux';
import { selectAssignment } from '../selectors/assignmentSelectors';
import { selectProgressForAssignment } from '../selectors/assignmentProgressSelectors';

export default function useAssignmentProgress(assignmentId) {
  const assignment = useSelector(s => (assignmentId ? selectAssignment(s, assignmentId) : null));
  const prerequisiteProgress = useSelector(s =>
    assignment && assignment.prerequisite_id ? selectProgressForAssignment(s, assignment.prerequisite_id) : null,
  );
  const assignmentProgress = useSelector(s => (assignmentId ? selectProgressForAssignment(s, assignmentId) : null));
  const prerequisiteComplete = !prerequisiteProgress || !!prerequisiteProgress.completed_at;

  return {
    assignment,
    assignmentProgress,
    prerequisiteComplete,
  };
}
